export { SettingsIcon } from "./settings";
